import React, { useEffect } from 'react';
import Webcam from 'react-webcam';
// import { RootContext } from '~/contextAPI/centerController';
import { openNotification } from '~/utils/antNotification';
import { errorMessCamera, position_name } from '~/utils/config';
import { useWindowSize } from '~/utils/gestSizeDevice';
import { WrappCamera } from '~/view/ui/components/ConfigStyle';

const portraitSetting = {
  facingMode: 'environment',
  width: 1080,
  height: 1920,
};

const defaultSettingsConfig = {
  width: 1920,
  height: 1080,
  facingMode: 'environment',
};

const CameraComponent = (props) => {
  const {
    countScreen = 1,
    imgRef,
    cameraSetting,
    typeImg = 'image/jpeg',
    zIndex,
    positionView,
    os = 'ios',
  } = props;
  const { defaultSetting } = cameraSetting;

  // const videoElement = document.getElementById('video');

  const isLandscape = useWindowSize().width > useWindowSize().height;

  function onUserMedia(stream) {
    // console.log('====================================');
    // console.log('Found Stream', stream);
    // console.log('====================================');
    // setCaptureSetting((state) => ({ ...state, hasStream: true }));
  }

  function onUserMediaError(err) {
    console.log('err: ', err);
    // openNotification({
    //   mess: errorMessCamera,
    //   time: 20,
    //   type: 'error',
    // });
    // setCaptureSetting((state) => ({ ...state, hasStream: false }));
  }

  // useEffect(() => {
  //   if (videoElement) {
  //     // Set the name of the hidden property and the change event for visibility
  //     let hidden, visibilityChange;
  //     if (typeof document.hidden !== 'undefined') {
  //       // Opera 12.10 and Firefox 18 and later support
  //       hidden = 'hidden';
  //       visibilityChange = 'visibilitychange';
  //     } else if (typeof document.msHidden !== 'undefined') {
  //       hidden = 'msHidden';
  //       visibilityChange = 'msvisibilitychange';
  //     } else if (typeof document.webkitHidden !== 'undefined') {
  //       hidden = 'webkitHidden';
  //       visibilityChange = 'webkitvisibilitychange';
  //     }
  //     console.log({ videoElement });
  //     // If the page is hidden, pause the video;
  //     // if the page is shown, play the video
  //     function handleVisibilityChange() {
  //       if (document[hidden]) {
  //         console.log('pause');
  //         videoElement.pause();
  //       } else {
  //         console.log('play');
  //         videoElement.play();
  //       }
  //     }

  //     // Warn if the browser doesn't support addEventListener or the Page Visibility API
  //     if (
  //       typeof document.addEventListener === 'undefined' ||
  //       hidden === undefined
  //     ) {
  //       console.log(
  //         'This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.'
  //       );
  //     } else {
  //       // Handle page visibility change
  //       document.addEventListener(
  //         visibilityChange,
  //         handleVisibilityChange,
  //         false
  //       );
  //     }
  //   }
  // }, [videoElement]);

  return (
    <WrappCamera zIndex={zIndex} isLandscape={isLandscape}>
      <Webcam
        key={countScreen}
        id="video"
        audio={false}
        ref={imgRef}
        screenshotQuality={0.92}
        onUserMedia={onUserMedia}
        screenshotFormat={os.toLowerCase() === 'ios' ? typeImg : 'image/webp'}
        forceScreenshotSourceSize={true}
        videoConstraints={
          !isLandscape && positionView === position_name['VIN']
            ? portraitSetting
            : defaultSetting
        }
        onUserMediaError={onUserMediaError}
        style={isLandscape ? {} : { height: '100%' }}
      />
    </WrappCamera>
  );
};

export default React.memo(CameraComponent);
